import React from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';

const ConfirmDeleteDialog = ({ open, userName, deleting, onConfirm, onClose }) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
    >
        <DialogTitle sx={{ fontWeight: 500 }}>Remove privilege</DialogTitle>
        <DialogContent>
            <Typography variant="body2" color="text.secondary">
                Are you sure you want to remove privileges for <strong>{userName}</strong>?
                This action cannot be undone.
            </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={onClose} variant="outlined" size="small" disabled={deleting}>
                Cancel
            </Button>
            <Button
                onClick={onConfirm}
                variant="contained"
                color="error"
                size="small"
                disableElevation
                disabled={deleting}
                startIcon={deleting ? <CircularProgress size={14} /> : null}
            >
                {deleting ? 'Removing...' : 'Remove'}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDeleteDialog;